import { cn } from '@/lib/utils';

interface GallerySectionProps {
  content: {
    title?: string;
    images?: { url: string; alt?: string; caption?: string }[];
    columns?: number;
  };
  variant?: string;
  layoutStyle?: string;
}

export function GallerySection({ content, variant = 'default', layoutStyle = 'classic' }: GallerySectionProps) {
  const {
    title,
    images = [],
    columns = 3,
  } = content;

  const isMinimal = layoutStyle === 'modern-minimal';
  const isPlayful = layoutStyle === 'playful-rounded';

  if (images.length === 0) {
    return (
      <section className="section-padding bg-background">
        <div className="container mx-auto px-4">
          <div className="text-center text-muted-foreground">
            No images in gallery
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section-padding bg-background">
      <div className="container mx-auto px-4">
        {title && (
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground text-center mb-12">
            {title}
          </h2>
        )}

        <div className={cn(
          "grid gap-4",
          columns === 2 && "grid-cols-1 md:grid-cols-2",
          columns === 3 && "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
          columns === 4 && "grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
        )}>
          {images.map((image, index) => (
            <div key={index} className="group relative overflow-hidden">
              <img 
                src={image.url} 
                alt={image.alt || ''} 
                className={cn(
                  "w-full aspect-square object-cover transition-transform duration-300 group-hover:scale-105",
                  isMinimal ? "rounded-none" : isPlayful ? "rounded-3xl" : "rounded-xl"
                )}
              />
              {image.caption && (
                <div className={cn(
                  "absolute inset-0 bg-foreground/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center p-4",
                  isPlayful && "rounded-3xl"
                )}>
                  <p className="text-white text-center text-sm">{image.caption}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}